export default function BrandText() {
  return (
    <span className="text-2xl font-semibold tracking-tight text-white">
      TP<span className="tp13-em">13</span>
    </span>
  );
}
